/**
 * Class names shared by the dynamic form fields. They map onto the
 * token-based `.form-*` rules in styles/components/forms.css, so fields
 * follow the project's input / checkbox / alert theme tokens rather than
 * hard-coded colors.
 */
export const FIELD_CLASS = 'form-input';
export const LABEL_CLASS = 'form-label';
export const LABEL_OPTIONAL_CLASS = 'form-label-optional';
export const CHOICE_GROUP_CLASS = 'form-choice-group';
export const CHOICE_CLASS = 'form-choice';
export const CHOICE_CONTROL_CLASS = 'form-choice-control';
export const TILES_CLASS = 'form-tiles';
export const TILE_CLASS = 'form-tile';
export const TILE_CONTROL_CLASS = 'form-tile-control';
export const TILE_ICON_CLASS = 'form-tile-icon';
export const TILE_LABEL_CLASS = 'form-tile-label';
export const TILE_DESCRIPTION_CLASS = 'form-tile-description';
export const TILE_CHECK_CLASS = 'form-tile-check';
